import React from 'react';

const BRAND_COLORS = {
  darkGray: '#555555',
  lightBlue: '#3895FF',
  blueDark: '#3182CE',
};

export function LogoEmblem({ size = 80, className = '', imageUrl = null }) {
  return (
    <img
      className={`logo-emblem ${className}`}
      src={imageUrl || '/brand/emblem-v2.png'}
      alt="logistiXnerd emblem"
      width={size}
      height={size}
      style={{ display: 'block', objectFit: 'contain', flexShrink: 0 }}
    />
  );
}

export function LogoWordmark({ width = 180, className = '' }) {
  return (
    <img
      className={`logo-wordmark ${className}`}
      src="/brand/wordmark-v2.png"
      alt="logistiXnerd"
      width={width}
      height={width * 231 / 985}
      style={{ display: 'block', maxWidth: '100%', objectFit: 'contain' }}
    />
  );
}

export function LogoFull({ emblemSize = 60, className = '', emblemUrl = null }) {
  return (
    <div className={`logo-full ${className}`}
      style={{ display: 'flex', alignItems: 'center', gap: emblemSize * 0.25 }}>
      <LogoEmblem size={emblemSize} imageUrl={emblemUrl} />
      <div className="logo-text" style={{ minWidth: 0 }}>
        <LogoWordmark width={Math.max(144, emblemSize * 3)} />
        <p style={{ margin: '4px 0 0', fontSize: 12, color: '#718096' }}>Fleet Management</p>
      </div>
    </div>
  );
}

export { BRAND_COLORS };
export default LogoEmblem;
